var render = function render(){
  var _vm$wheelSegmentTitle, _vm$wheelSegmentTitle2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "spectrumWheelBodyRef",
    staticClass: "spectrum-wheel-body"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isDesktop && !_vm.zoomEnabled,
      expression: "isDesktop && !zoomEnabled"
    }],
    staticClass: "spectrum-wheel-desktop-select",
    style: {
      width: '40%',
      height: '40%',
      bottom: _vm.defaultProjectSpectrumArrowPosition.bottom,
      left: _vm.defaultProjectSpectrumArrowPosition.left,
      zIndex: 0
    },
    attrs: {
      "src": require("../../../assets/images/SelectOptionDesktop.png")
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMobile && !_vm.zoomEnabled,
      expression: "isMobile && !zoomEnabled"
    }],
    staticClass: "spectrum-wheel-mobile-select",
    style: {
      width: '40%'
    },
    attrs: {
      "src": require("../../../assets/images/SelectOptionMobile.png")
    }
  }), _c('div', {
    staticClass: "spectrum-wheel-skin",
    style: {
      width: this.nativeWidth + 'px',
      height: this.computedSpectrumWheelHeight + 'px'
    }
  }, [_vm.zoomEnabled ? _c('img', {
    staticClass: "spectrun-wheel-pimple",
    style: _vm.isDesktop ? {
      width: '164px',
      height: '80px',
      top: _vm.backToAllOptionsDesktopPositioning[_vm.selectedSegmentIndex].top,
      left: _vm.backToAllOptionsDesktopPositioning[_vm.selectedSegmentIndex].left
    } : {
      top: '8%',
      left: '50%',
      transform: 'translate(-50%, 0)',
      width: '40%'
    },
    attrs: {
      "src": _vm.isDesktop && _vm.selectedSegmentIndex === 4 ? require('../../../assets/images/spectrum-wheel/back-to-all-options-black.svg') : require('../../../assets/images/spectrum-wheel/back-to-all-options.svg'),
      "alt": "back to all options button"
    },
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.resetZoom();
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "spectrum-wheel-dermis",
    style: {
      width: this.nativeWidth + 'px',
      height: this.nativeHeight + 'px',
      top: _vm.isDesktop ? '-13%' : _vm.dermisPositioning[_vm.selectedSegmentIndex] ? _vm.dermisPositioning[_vm.selectedSegmentIndex].positionTop + 'px' : '0px',
      left: _vm.isDesktop ? '0px' : _vm.dermisPositioning[_vm.selectedSegmentIndex] ? _vm.dermisPositioning[_vm.selectedSegmentIndex].positionLeft + 'px' : '0px'
    }
  }, [!_vm.zoomEnabled ? _c('div', {
    staticClass: "spectrum-wheel-guts",
    style: {
      width: this.spectrumWheelGutsWidth + 'px',
      height: this.spectrumWheelGutsHeight + 'px'
    }
  }, [_c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(0);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[0].matrix,
      "rotation": _vm.segentPositioning[0].rotation,
      "positionTop": _vm.segentPositioning[0].positionTop,
      "positionLeft": _vm.segentPositioning[0].positionLeft,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-1.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-1.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 0,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(1);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[1].matrix,
      "rotation": _vm.segentPositioning[1].rotation,
      "positionTop": _vm.segentPositioning[1].positionTop,
      "positionLeft": _vm.segentPositioning[1].positionLeft,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-2.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-2.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 1,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(2);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[2].matrix,
      "rotation": _vm.segentPositioning[2].rotation,
      "positionTop": _vm.segentPositioning[2].positionTop,
      "positionLeft": _vm.segentPositioning[2].positionLeft,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-3.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-3.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 2,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(3);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[3].matrix,
      "rotation": _vm.segentPositioning[3].rotation,
      "positionTop": _vm.segentPositioning[3].positionTop,
      "positionLeft": _vm.segentPositioning[3].positionLeft,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-4.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-4.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 3,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(4);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[4].matrix,
      "rotation": _vm.segentPositioning[4].rotation,
      "positionTop": _vm.segentPositioning[4].positionTop,
      "positionRight": _vm.segentPositioning[4].positionRight,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-5.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-5.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 4,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(5);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[5].matrix,
      "rotation": _vm.segentPositioning[5].rotation,
      "positionTop": _vm.segentPositioning[5].positionTop,
      "positionRight": _vm.segentPositioning[5].positionRight,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-6.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-6.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 5,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), _c('WheelSeg', {
    attrs: {
      "clickHandler": function () {
        _vm.setZoom(6);
      },
      "mouseleaveHandler": function () {
        _vm.resetZoom();
      },
      "matrix": _vm.segentPositioning[6].matrix,
      "rotation": _vm.segentPositioning[6].rotation,
      "positionTop": _vm.segentPositioning[6].positionTop,
      "positionRight": _vm.segentPositioning[6].positionRight,
      "defaultImage": require('../../../assets/images/spectrum-wheel/image-7.png'),
      "hoverImage": require('../../../assets/images/spectrum-wheel/image-7.png'),
      "isMobileView": _vm.isMobile && _vm.zoomEnabled,
      "wheelSegmentIndex": 6,
      "initialDefaultHoveredValues": _vm.initialDefaultHover
    },
    on: {
      "resetDefaultHoverValues": _vm.resetInitialDefaultHover
    }
  }), !_vm.zoomEnabled ? _c('img', {
    staticClass: "ps-logo",
    style: {
      position: 'absolute',
      zIndex: 1,
      width: _vm.psLogoPositioning.width + 'px',
      left: _vm.psLogoPositioning.positionLeft + 'px',
      top: _vm.psLogoPositioning.positionTop + 'px'
    },
    attrs: {
      "alt": "project spectrum logo",
      "src": require("../../../assets/images/spectrum-wheel/ps-logo.png")
    }
  }) : _vm._e()], 1) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile && _vm.zoomEnabled,
      expression: "!isMobile && zoomEnabled"
    }],
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute"
    }
  }, [_c('img', {
    staticClass: "img-fluid w-100 h-100",
    attrs: {
      "alt": "wheel segment image",
      "src": _vm.wheelSegmentDesktopBackgroundImages[_vm.selectedSegmentIndex]
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMobile && _vm.zoomEnabled,
      expression: "isMobile && zoomEnabled"
    }],
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100px",
      "height": "auto",
      "font-size": "18px",
      "font-weight": "700",
      "text-align": "center",
      "font-family": "Rajdhani"
    },
    style: {
      top: '50%',
      left: '50%',
      transform: _vm.selectedSegmentIndex === 2 || _vm.selectedSegmentIndex === 5 ? 'translate(-50%, -15%)' : 'translate(-50%, 50%)',
      color: (_vm$wheelSegmentTitle = _vm.wheelSegmentTitles[_vm.selectedSegmentIndex]) === null || _vm$wheelSegmentTitle === void 0 ? void 0 : _vm$wheelSegmentTitle.color
    }
  }, [_vm._v(" " + _vm._s((_vm$wheelSegmentTitle2 = _vm.wheelSegmentTitles[_vm.selectedSegmentIndex]) === null || _vm$wheelSegmentTitle2 === void 0 ? void 0 : _vm$wheelSegmentTitle2.title) + " ")]), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.wheelSegmentMobileImages[_vm.selectedSegmentIndex],
      "alt": "image caption"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }